var render = function render(){var _vm=this,_c=_vm._self._c;return _c('money',_vm._b({staticClass:"sosInput",attrs:{"disabled":_vm.disabled},on:{"input":_vm.onInput},nativeOn:{"focus":function($event){return _vm.onFocus($event)},"blur":function($event){return _vm.onBlur.apply(null, arguments)}},model:{value:(_vm.money),callback:function ($$v) {_vm.money=$$v},expression:"money"}},'money',_vm.configCurrency,false))
}
var staticRenderFns = []

export { render, staticRenderFns }